import React from 'react';
import { Modal, ModalHeader, Button } from 'reactstrap';
import { FormSpecimen } from './FormSpecimen';
import { ModalButtonSave, ModalButtonUpdate,  } from '../../constant';
import { Dialog } from 'primereact/dialog';

export const ModalSpecimens = (props) => {

    const{
        modal, modalTitle, closeDialog, method, loading,
        name, abbreviation, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete
    } = props;
    
    const footer = (
        <div>
            
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                Confirmar
            </Button>

        </div>
    );


    return (
        <Dialog 
            header={modalTitle} 
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            footer={footer}>
            {
                method === "create"
                ? 
                    <FormSpecimen
                        button={ModalButtonSave}
                        {...{loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                :
                    (method === "update")
                        ?
                            <FormSpecimen
                                button={ModalButtonUpdate}
                                {...{loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation }}
                            />
                        :
                          null
            }
        </Dialog>

        
    )
}
